<template>
    <div class="home">
        <div class="paiCarousel">
               <HomeSlides />
         </div>
        <div class="sobreNosHome">
            <b-container fluid class="conteudoHome1" style="padding-left: 0px; padding-right: 0px;">
                <b-row  no-gutters class="sobreNosHomeL1">
                    <b-col cols="12" />
                </b-row>

                <!-- Estratégia para telas médias e maiores -->
                <mq-layout mq="sm+">
                    <b-row  no-gutters class="sobreNosHomeL2">
                        <b-col sm="12" lg="1" order-sm="5" order-lg="1" />
                        <b-col sm="2" lg="1" order-sm="1" order-lg="2" class="text-sm-center">
                            <div  class="linhaHorizontalEsquerdaAbout"><LinhaHorizontalY :configLinhasY="configLinhasAboutHomeY" /></div>
                        </b-col>
                        <b-col sm="8" lg="4" order-sm="2" order-lg="3" class="text-sm-center text-lg-left TituloAbout">
                            <strong>HION é TECNOLOGIA Brasileira </strong> em <strong>Sistemas</strong> de Armazenamento de <strong>Energia</strong>,
                            Sistemas <strong>Embarcados</strong>, Energias <strong>Renováveis</strong>, IoT, Veículos <strong>Híbridos</strong> e Elétricos,
                            Gestão de <strong>Projetos</strong>, Consultoria, Auditoria e Gestão da <strong>Qualidade</strong> - ABNT NBR ISO 9001.
                        </b-col>
                        <b-col sm="12" lg="4" order-sm="4" order-lg="7" class="text-sm-center text-lg-left TextoAbout">
                            Desenvolvemos soluções eficientes e rentáveis atendendo os mais altos requisitos de robustez e qualidade.
                            Soluções técnicas e administrativas para otimizar seu plano estratégico, 
                            seus produtos e seus processos. Atuando de forma customizada para cada projeto adotando 
                            padrões modernos de sustentabilidade e respeitando o perfil e as necessidade de cada cliente.
                        </b-col>
                        <b-col sm="2" lg="1" order-sm="3" order-lg="11" class="text-sm-center">
                            <div  class="linhaHorizontalDireitaAbout"><LinhaHorizontal :configLinhas="configLinhasAboutHome" /></div>
                        </b-col>
                        <b-col sm="12" lg="1" order-sm="6" order-lg="12" />
                    </b-row>
                </mq-layout>
                <!-- Final da estrategia em telas medias e maiores -->

                <!-- Estratégia para telas pequenas -->
                <mq-layout mq="xs">
                    <b-row  no-gutters class="sobreNosHomeL2">     
                        <b-col cols="12" order="1" class="text-center TituloAbout">
                            <strong>HION é TECNOLOGIA Brasileira </strong> em <strong>Sistemas</strong> de Armazenamento de <strong>Energia</strong>,
                            Sistemas <strong>Embarcados</strong>, Energias <strong>Renováveis</strong>, IoT, Veículos <strong>Híbridos</strong> e Elétricos,
                            Gestão de <strong>Projetos</strong>, Consultoria, Auditoria e Gestão da <strong>Qualidade</strong> - ABNT NBR ISO 9001.
                        </b-col>
                        <b-col cols="12" order="2" class="text-center TextoAbout">
                            Desenvolvemos soluções eficientes e rentáveis atendendo os mais altos requisitos de robustez e qualidade.
                            Soluções técnicas e administrativas para otimizar seu plano estratégico, 
                            seus produtos e seus processos. Atuando de forma customizada para cada projeto adotando 
                            padrões modernos de sustentabilidade e respeitando o perfil e as necessidade de cada cliente.
                        </b-col>
                    </b-row>
                </mq-layout>
                <!-- Final da estrategia em telas pequenas -->

                <b-row  no-gutters class="sobreNosHomeL3">
                    <b-col cols="12" class="text-center">
                        <div class="argdir"><ArgolasEffect :configArgolas="configArgolas" /> </div>
                    </b-col>
                </b-row>

                <b-row  no-gutters class="sobreNosHomeL4">
                    <b-col cols="12" sm="12" lg="2" order="4" order-sm="4" order-lg="1" />
                    <b-col cols="12" sm="4" lg="2" order="1" order-sm="1" order-lg="3" class="text-center text-lg-center" @click="EmiteSomos"> 
                        <b-img-lazy :src="require('../../assets/hion_32.jpg')" 
                            alt="Hion Tecnologia" 
                            class="thumbSomos">
                        </b-img-lazy>
                        <div class="thumbLegenda">QUEM SOMOS</div>
                    </b-col>
                    <b-col cols="12" sm="12" lg="1" order="5" order-sm="5" order-lg="5" />
                    <b-col cols="12" sm="4" lg="2" order="2" order-sm="2" order-lg="6" class="text-center text-lg-center"  @click="EmiteValores">
                        <b-img-lazy :src="require('../../assets/hion_34.jpg')" 
                            alt="Hion Tecnologia" 
                            class="thumbSomos">
                        </b-img-lazy>
                        <div class="thumbLegenda">VALORES</div>
                    </b-col>
                    <b-col cols="12" sm="12" lg="1" order="6" order-sm="6" order-lg="8" />
                    <b-col cols="12" sm="4" lg="2" order="3" order-sm="3" order-lg="9" class="text-center text-lg-center"  @click="EmiteMissao">
                        <b-img-lazy :src="require('../../assets/hion_36.jpg')"
                            alt="Hion Tecnologia" 
                            class="thumbSomos">
                        </b-img-lazy>
                        <div class="thumbLegenda">MISSÃO</div>
                    </b-col>
                    <b-col cols="12" sm="12" lg="2" order="7" order-sm="7" order-lg="11" />
                </b-row>

                <b-row  no-gutters class="sobreNosHomeL5">
                    <b-col cols="12" />
                </b-row>
            </b-container>
        </div>

        <div class="smartHome">
            <b-container fluid class="frontendSmartHome" style="padding-left: 0px; padding-right: 0px;">
                <router-link style="text-decoration: none;" to="/Tecnologia">
                <!-- Estratégia para telas médias e maiores -->
                    <mq-layout mq="lg+">
                        <b-row  no-gutters class="smartHomeX1">
                            <b-col lg="6" order-lg="1">
                                <b-row  no-gutters class="smartHomeL1">
                                    <b-col cols="12" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL2">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="8" order-lg="3" class="text-lg-left">
                                        <div class="tituloSmartHome">Baterias Inteligentes</div>
                                    </b-col>
                                    <b-col lg="2" order-lg="11" class="text-lg-left" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL3">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="8" order-lg="3" class="text-lg-left">
                                        <div class="subTituloSmartHome">EFICIÊNCIA, AUTONOMIA E SUSTENTABILIDADE</div>
                                    </b-col>
                                    <b-col lg="2" order-lg="11" class="text-lg-left" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL4">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="8" order-lg="3" class="text-lg-left">
                                        <div class="textoSmartHome">
                                            As <strong>Baterias Inteligentes HION</strong> apresentam 
                                            um custo muito melhor ao longo de sua vida útil e dispensam qualquer ação de manutenção. 
                                            Tornando-as um <strong>investimento valioso</strong> e uma <strong>solução inteligente</strong> a longo prazo.
                                        </div>
                                    </b-col>
                                    <b-col lg="2" order-lg="11" class="text-lg-left" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL5">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="10" order-lg="3" class="text-lg-left">
                                        <div class="efeitoIconSmartHome">
                                            <i class="fas fa-play-circle"></i>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col lg="6" order-lg="2">
                                <mq-layout mq="xl">
                                    <b-img-lazy 
                                        :src="require('../../assets/bmsHome-hd.jpg')"
                                        alt="Baterias Inteligentes" 
                                        class="imgSmartHome"
                                        >
                                    </b-img-lazy>
                                </mq-layout>
                                <mq-layout mq="lg">
                                    <b-img-lazy 
                                        :src="require('../../assets/bmsHome-lg.jpg')"
                                        alt="Baterias Inteligentes" 
                                        class="imgSmartHome"
                                        >
                                    </b-img-lazy>
                                </mq-layout>
                            </b-col>
                        </b-row>
                    </mq-layout>
                <!-- FINAL da Estratégia para telas Large e Extra Large -->
                
                <!-- Estratégia para telas médias e pequenas -->
                <mq-layout :mq="['xs', 'sm', 'md']">
                    <b-row  no-gutters class="smartHomeX1">
                        <b-col cols="12" sm="12" order="1" order-sm="1" class="imgSmartHomeParent">
                            <mq-layout :mq="['sm', 'md']">
                                <b-img-lazy 
                                    :src="require('../../assets/bmsHome-sm.jpg')"
                                    alt="Baterias Inteligentes" 
                                    class="imgSmartHome"
                                    >
                                </b-img-lazy>
                            </mq-layout>
                            <mq-layout mq="xs">
                                <b-img-lazy 
                                    :src="require('../../assets/bmsHome-xs.jpg')"
                                    alt="Baterias Inteligentes" 
                                    class="imgSmartHome"
                                    >
                                </b-img-lazy>
                            </mq-layout>
                        </b-col>
                    </b-row>
                    <b-row  no-gutters class="smartHomeL1">
                        <b-col cols="12" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL2">
                        <b-col cols="1" sm="2" order="1" order-sm="1" class="text-center" />
                        <b-col cols="10" sm="8" order="2" order-sm="3" class="text-center">
                            <div class="tituloSmartHome">Baterias Inteligentes</div>
                        </b-col>
                        <b-col cols="1" sm="2" order="12" order-sm="11" class="text-center" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL3">
                        <b-col cols="1" sm="2" order="1" order-sm="1" class="text-center" />
                        <b-col cols="10" sm="8" order="2" order-sm="3" class="text-center">
                            <div class="subTituloSmartHome">EFICIÊNCIA, AUTONOMIA E SUSTENTABILIDADE</div>
                        </b-col>
                        <b-col cols="1" sm="2" order="12" order-sm="11" class="text-center" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL4">
                        <b-col cols="1" sm="2" order="1" order-sm="1" class="text-center" />
                        <b-col cols="10" sm="8" order="2" order-sm="3" class="text-center">
                            <div class="textoSmartHome">
                                As <strong>Baterias Inteligentes HION</strong> apresentam 
                                um custo muito melhor ao longo de sua vida útil e dispensam qualquer ação de manutenção. 
                                Tornando-as um <strong>investimento valioso</strong> e uma <strong>solução inteligente</strong> a longo prazo.
                            </div>
                        </b-col>
                        <b-col cols="1" sm="2" order="12" order-sm="11" class="text-center" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL5">
                        <b-col cols="12" order="1" class="text-center">
                            <div class="efeitoIconSmartHome">
                                <i class="fas fa-play-circle"></i>
                            </div>
                        </b-col>
                    </b-row>
                </mq-layout>
                <!-- FINAL da Estratégia para telas Medias e Pequenas -->
                </router-link>
            </b-container>
        </div>

        <div class="smartHome" id="BMShion">
            <b-container fluid class="frontendSmartHome" style="padding-left: 0px; padding-right: 0px;">
                <router-link style="text-decoration: none;" to="/KinderBMS">
                <!-- Estratégia para telas médias e maiores -->
                    <mq-layout mq="lg+">
                        <b-row  no-gutters class="smartHomeX1">
                            <b-col lg="6" order-lg="2">
                                <b-row  no-gutters class="smartHomeL1">
                                    <b-col cols="12" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL2">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="8" order-lg="3" class="text-lg-left">
                                        <div class="tituloSmartHome" id="tituloBmsHionHome">Sistema BMS HION</div>
                                    </b-col>
                                    <b-col lg="2" order-lg="11" class="text-lg-left" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL3">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="8" order-lg="3" class="text-lg-left">
                                        <div class="subTituloSmartHome" id="subTituloBmsHionHome">PROTEÇÃO, SEGURANÇA, INTELIGÊNCIA E CONECTIVIDADE</div>
                                    </b-col>
                                    <b-col lg="2" order-lg="11" class="text-lg-left" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL4">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="8" order-lg="3" class="text-lg-left">
                                        <div class="textoSmartHome" id="textoBmsHionHome">
                                            Combinam de forma exclusiva os benefícios do Lítio com o poder e
                                            a conectividade que o <strong>Sistema Gerenciador de Baterias HION</strong> proporciona.
                                        </div>
                                    </b-col>
                                    <b-col lg="2" order-lg="11" class="text-lg-left" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL5">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="10" order-lg="3" class="text-lg-left">
                                        <div class="efeitoIconSmartHome" id="PlaySmartEnergy">
                                            <i class="fas fa-play-circle"></i>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col lg="6" order-lg="1" class="imgBMShionParent">
                                <mq-layout mq="xl">
                                    <b-img-lazy 
                                        :src="require('../../assets/smartHome-hd.jpg')"
                                        alt="BMS HION" 
                                        class="imgSmartHome"
                                        id="imgBMShion"
                                        >
                                    </b-img-lazy>
                                </mq-layout>
                                <mq-layout mq="lg">
                                    <b-img-lazy 
                                        :src="require('../../assets/smartHome-lg.jpg')"
                                        alt="BMS HION" 
                                        class="imgSmartHome"
                                        id="imgBMShion"
                                        >
                                    </b-img-lazy>
                                </mq-layout>
                            </b-col>
                        </b-row>
                    </mq-layout>
                <!-- FINAL da Estratégia para telas Large e Extra Large -->
                
                <!-- Estratégia para telas médias e pequenas -->
                <mq-layout :mq="['xs', 'sm', 'md']">
                    <b-row  no-gutters class="smartHomeX1">
                        <b-col cols="12" sm="12" order="1" order-sm="1" class="imgSmartHomeParent">
                            <mq-layout :mq="['sm', 'md']">
                                <b-img-lazy 
                                    :src="require('../../assets/smartHome-sm.jpg')"
                                    alt="BMS HION" 
                                    class="imgSmartHome"
                                    >
                                </b-img-lazy>
                            </mq-layout>
                            <mq-layout mq="xs">
                                <b-img-lazy 
                                    :src="require('../../assets/smartHome-xs.jpg')"
                                    alt="BMS HION" 
                                    class="imgSmartHome"
                                    >
                                </b-img-lazy>
                            </mq-layout>
                        </b-col>
                    </b-row>
                    <b-row  no-gutters class="smartHomeL1">
                        <b-col cols="12" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL2">
                        <b-col cols="1" sm="2" order="1" order-sm="1" class="text-center" />
                        <b-col cols="10" sm="8" order="2" order-sm="3" class="text-center">
                            <div class="tituloSmartHome" id="tituloBmsHionHome">Sistema BMS HION</div>
                        </b-col>
                        <b-col cols="1" sm="2" order="12" order-sm="11" class="text-center" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL3">
                        <b-col cols="1" sm="2" order="1" order-sm="1" class="text-center" />
                        <b-col cols="10" sm="8" order="2" order-sm="3" class="text-center">
                            <div class="subTituloSmartHome" id="subTituloBmsHionHome">PROTEÇÃO, SEGURANÇA, INTELIGÊNCIA E CONECTIVIDADE</div>
                        </b-col>
                        <b-col cols="1" sm="2" order="12" order-sm="11" class="text-center" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL4">
                        <b-col cols="1" sm="2" order="1" order-sm="1" class="text-center" />
                        <b-col cols="10" sm="8" order="2" order-sm="3" class="text-center">
                            <div class="textoSmartHome" id="textoBmsHionHome">
                                Combinam de forma exclusiva os benefícios do Lítio com o poder e
                                a conectividade que o <strong>Sistema Gerenciador de Baterias HION</strong> proporciona.
                            </div>
                        </b-col>
                        <b-col cols="1" sm="2" order="12" order-sm="11" class="text-center" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL5">
                        <b-col cols="12" order="1" class="text-center">
                            <div class="efeitoIconSmartHome" id="PlaySmartEnergy">
                                <i class="fas fa-play-circle"></i>
                            </div>
                        </b-col>
                    </b-row>
                </mq-layout>
                <!-- FINAL da Estratégia para telas Medias e Pequenas -->
                </router-link>
            </b-container>
        </div>

        <div class="smartHome" id="smartEnergy">
            <b-container fluid class="frontendSmartHome" style="padding-left: 0px; padding-right: 0px;">
                <router-link style="text-decoration: none;" to="/SmartHomes">
                <!-- Estratégia para telas médias e maiores -->
                    <mq-layout mq="lg+">
                        <b-row  no-gutters class="smartHomeX1">
                            <b-col lg="6" order-lg="1">
                                <b-row  no-gutters class="smartHomeL1">
                                    <b-col cols="12" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL2">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="8" order-lg="3" class="text-lg-left">
                                        <div class="tituloSmartHome">Smart Energy</div>
                                    </b-col>
                                    <b-col lg="2" order-lg="11" class="text-lg-left" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL3">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="8" order-lg="3" class="text-lg-left">
                                        <div class="subTituloSmartHome">PARA INDÚSTRIAS, COMÉRCIOS E RESIDÊNCIAS</div>
                                    </b-col>
                                    <b-col lg="2" order-lg="11" class="text-lg-left" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL4">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="8" order-lg="3" class="text-lg-left">
                                        <div class="textoSmartHome">
                                            O <strong>BMS HION</strong> coleta dados em tempo real
                                            da <strong>Bateria Inteligente</strong> e transmite para a nuvem <strong>HION</strong>
                                            através do wi-fi. Os dados são armazenador de forma segura e transmitidos
                                            para outros dispositivos.<br><br>
                                            Tenha o controle remoto através de um sistema inteligente, seguro  conectado.
                                        </div>
                                    </b-col>
                                    <b-col lg="2" order-lg="11" class="text-lg-left" />
                                </b-row>
                                <b-row  no-gutters class="smartHomeL5">
                                    <b-col lg="2" order-lg="1" class="text-lg-left" />
                                    <b-col lg="10" order-lg="3" class="text-lg-left">
                                        <div class="efeitoIconSmartHome" id="PlaySmartEnergy">
                                            <i class="fas fa-play-circle"></i>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col lg="6" order-lg="2">
                                <mq-layout mq="xl">
                                    <b-img-lazy 
                                        :src="require('../../assets/smartEnergy-hd.jpg')"
                                        alt="Smart Energy" 
                                        class="imgSmartHome"
                                        >
                                    </b-img-lazy>
                                </mq-layout>
                                <mq-layout mq="lg">
                                    <b-img-lazy 
                                        :src="require('../../assets/smartEnergy-lg.jpg')"
                                        alt="SmartEnergy" 
                                        class="imgSmartHome"
                                        >
                                    </b-img-lazy>
                                </mq-layout>
                            </b-col>
                        </b-row>
                    </mq-layout>
                <!-- FINAL da Estratégia para telas Large e Extra Large -->
                
                <!-- Estratégia para telas médias e pequenas -->
                <mq-layout :mq="['xs', 'sm', 'md']">
                    <b-row  no-gutters class="smartHomeX1">
                        <b-col cols="12" sm="12" order="1" order-sm="1" class="imgSmartHomeParent">
                            <mq-layout :mq="['sm', 'md']">
                                <b-img-lazy 
                                    :src="require('../../assets/smartEnergy-sm.jpg')"
                                    alt="Smart Energy" 
                                    class="imgSmartHome"
                                    >
                                </b-img-lazy>
                            </mq-layout>
                            <mq-layout mq="xs">
                                <b-img-lazy 
                                    :src="require('../../assets/smartEnergy-xs.jpg')"
                                    alt="Smart Energy" 
                                    class="imgSmartHome"
                                    >
                                </b-img-lazy>
                            </mq-layout>
                        </b-col>
                    </b-row>
                    <b-row  no-gutters class="smartHomeL1">
                        <b-col cols="12" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL2">
                        <b-col cols="1" sm="2" order="1" order-sm="1" class="text-center" />
                        <b-col cols="10" sm="8" order="2" order-sm="3" class="text-center">
                            <div class="tituloSmartHome">Smart Energy</div>
                        </b-col>
                        <b-col cols="1" sm="2" order="12" order-sm="11" class="text-center" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL3">
                        <b-col cols="1" sm="2" order="1" order-sm="1" class="text-center" />
                        <b-col cols="10" sm="8" order="2" order-sm="3" class="text-center">
                            <div class="subTituloSmartHome">PARA INDÚSTRIAS, COMÉRCIOS E RESIDÊNCIAS</div>
                        </b-col>
                        <b-col cols="1" sm="2" order="12" order-sm="11" class="text-center" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL4">
                        <b-col cols="1" sm="2" order="1" order-sm="1" class="text-center" />
                        <b-col cols="10" sm="8" order="2" order-sm="3" class="text-center">
                            <div class="textoSmartHome">
                                <br><br>
                                Tenha o controle remoto através de um sistema inteligente, seguro  conectado.
                            </div>
                        </b-col>
                        <b-col cols="1" sm="2" order="12" order-sm="11" class="text-center" />
                    </b-row>
                    <b-row  no-gutters class="smartHomeL5">
                        <b-col cols="12" order="1" class="text-center">
                            <div class="efeitoIconSmartHome" id="PlaySmartEnergy">
                                <i class="fas fa-play-circle"></i>
                            </div>
                        </b-col>
                    </b-row>
                </mq-layout>
                <!-- FINAL da Estratégia para telas Medias e Pequenas -->
                </router-link>
            </b-container>
        </div>

        <div class="contatoHome">
            <b-container fluid class="frontendContatotHome" style="padding-left: 0px; padding-right: 0px;">
                    <b-row  no-gutters class="contatoHomeL1">
                        <b-col cols="12">
                            <div class="efeitoLogoContatoHome1">
                                <HionEffect class="HionEffectHomeContato1" :configHionEffect="configHionEffectHomeContato" />
                            </div>
                        </b-col>
                    </b-row>
                    <b-row  no-gutters class="contatoHomeL2">
                        <b-col cols="12" lg="1" order="1" order-lg="1" />
                        <b-col cols="12" lg="5" order="1" order-lg="2" class="text-center text-lg-left">
                            <router-link style="text-decoration: none;" to="/Contatos">
                                <div class="tituloContatoHome">Pronto para começar um novo projeto?<br>Fale com a gente!</div>
                            </router-link>
                        </b-col>
                        <b-col cols="12" lg="5" order="1" order-lg="7" class="text-center text-lg-left">
                            <div class="formContatoHome">
                                <b-form @submit="SubmitFormContatoHome">
                                    <b-form-group id="FormGrupoNome">
                                        <b-form-input
                                        id="input-Nome-Contato"
                                        v-model="form.nome"
                                        required
                                        placeholder="seu nome"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group id="FormGrupoEmail">
                                        <b-row>
                                            <b-col lg="6">
                                                <b-form-input
                                                    id="input-Telefone-Contato"
                                                    v-model="form.telefone"
                                                    required
                                                    placeholder="(    ) _____-____">
                                                </b-form-input>
                                            </b-col>
                                            <b-col lg="6">
                                                <b-form-input
                                                    id="input-Email-Contato"
                                                    v-model="form.email"
                                                    type="email"
                                                    required
                                                    placeholder="seu e-mail">
                                                </b-form-input>
                                            </b-col>
                                        </b-row>
                                    </b-form-group>

                                    <b-form-group id="FormGrupoMensagem">
                                        <b-form-input
                                        id="input-Mensagem-Contato"
                                        v-model="form.mensagem"
                                        required
                                        placeholder="mensagem"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-button type="submit" class="botaoFormContato">Enviar</b-button>
                                </b-form>
                            </div>
                        </b-col>
                        <b-col cols="12" lg="1" order="1" order-lg="11" class="text-center text-lg-left" />
                    </b-row>
                    <b-row  no-gutters class="contatoHomeL3">
                        <b-col cols="12" />
                    </b-row>
            </b-container>
        </div>

        <div class="newsletterHome">
            <b-container fluid class="containerNewsletter" style="padding-left: 0px; padding-right: 0px;">
                <b-row  no-gutters class="rowNewsletterL1">
                    <b-col cols="12" />
                </b-row>
                <b-row  no-gutters class="rowNewsletterL2">
                    <b-col cols="12" lg="1" order="1" order-lg="1" />
                    <b-col cols="12" lg="4" order="2" order-lg="2" class="text-center text-lg-left textoNewsletterHome">
                        Fique por dentro de nossas novidades.
                    </b-col>
                    <b-col cols="12" lg="2" order="3" order-lg="6" class="text-center text-lg-center textoNewsletterHome">
                        Inscreva-se:
                    </b-col>
                    <b-col cols="12" lg="5" order="4" order-lg="8" class="text-center inputNewsletterHome">
                        <b-form @submit="SubmitFormNewsletterHome">
                            <b-form-group id="FormGrupoNewsletter">
                                <b-form-input
                                id="input-Email-Newsletter"
                                v-model="newsletter.email"
                                type="email"
                                required
                                placeholder="seuemail@gmail.com                        > "
                                v-on:keyup.enter="submit"
                                ></b-form-input>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row  no-gutters class="rowNewsletterL3">
                    <b-col cols="12" />
                </b-row>
            </b-container>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Home',
    components: { 
        ArgolasEffect: () => import(/* webpackChunkName: "ArgolasEffecthome" */ "../efeitos/Argolas.vue"), 
        HomeSlides: () => import(/* webpackChunkName: "HomeSlideshome" */ "../efeitos/HomeSlides.vue"), 
        AneisEffect: () => import(/* webpackChunkName: "AneisEffecthome" */ "../efeitos/Aneis.vue"), 
        LinhaHorizontal: () => import(/* webpackChunkName: "LinhaHorizontalhome" */ "../efeitos/LinhaHorizontal.vue"), 
        LinhaHorizontalY: () => import(/* webpackChunkName: "LinhaHorizontalYhome" */ "../efeitos/LinhaHorizontalY.vue"), 
        HionEffect: () => import(/* webpackChunkName: "HionEffecthome" */ "../efeitos/hion_globo.vue"),
    },
    data() {
        return {
            configLinhasAboutHome: {
                backgroundLinhas: "#eee",
                CorLinhas: "#2e2d2c"
            },
            configLinhasAboutHomeY: {
                backgroundLinhasY: "#eee",
                CorLinhasY: "#2e2d2c"
            },
            configArgolas: {
                backgroundArgolas: "#eee",
                CorArgola: "#2e2d2c"
            },         
            configHionEffectHomeContato: {
                backgroundHionEffect: "#fff",
                CorHionEffect:"#008fac",
            },
            form: {
                nome: '',
                telefone: '',
                email: '',
                mensagem: ''
            },
            newsletter: {
                email: ''
            }

        };
    },
    methods: {
        SubmitFormContatoHome(evt) {
            evt.preventDefault()
            alert(JSON.stringify(this.form))
        },
        SubmitFormNewsletterHome(evt) {
            evt.preventDefault()
            alert('Cadastro Realizado com Sucesso - '+ JSON.stringify(this.newsletter))
        },
        EmiteSomos() {
            this.$router.push({
                name: 'About',
                params: {
                    EventoThumblerlHome: 'QuemSomos'
                }
            })
        },
        EmiteValores() {
            this.$router.push({
                name: 'About',
                params: {
                    EventoThumblerlHome: 'Valores'
                }
            })
        },
        EmiteMissao() {
            this.$router.push({
                name: 'About',
                params: {
                    EventoThumblerlHome: 'Missao'
                }
            })
        }
    }
};
</script>

<style>
.home {
    background:#eee;
    color:white;
    height: 100%;
}
.paiCarousel {
    height: 650px;
    width: 100%;
    max-width: 1920px;
}

/*************** inicio do CSS de Soluções e Tecnologia **********/
.sobreNosHome {
    height: 847px;
    width: 100%;
    background: #eee;
}
.conteudoHome1 {
    margin: 0;
}
.sobreNosHomeL1 {
    margin: 0;
    height: 95px;
}
.sobreNosHomeL2 {
    margin: 0;
    height: 295px;
}
.sobreNosHomeL3 {
    margin: 0;
    height: 105px;
}
.sobreNosHomeL4 {
    margin: 0;
    height: 257px;
}
.sobreNosHomeL5 {
    margin: 0;
    height: 95px;
}
.linhaHorizontalEsquerdaAbout {
    transform: rotate(270deg);
    width: 295px;
    height: 67.6px;
    margin-top: 112px;
    margin-left: -92px;
    opacity: 0.7;
}
.linhaHorizontalDireitaAbout {
    transform: rotate(270deg);
    width: 295px;
    height: 67.6px;
    margin-top: 112px;
    margin-left: -92px;
    opacity: 0.7;
}
.TituloAbout {
    color: #2e2d2c;
    font-family: 'Raleway', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Verdana, sans-serif;
    padding: 35px !important;
    font-size: 18px;
}
.TextoAbout {
    color:#2e2d2c;
    font-family: 'Raleway', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Verdana, sans-serif;
    padding: 35px !important;
    font-size: 16px;
}
.argdir {
    width: 30px;
    height: 60px;
    position: absolute;
    top: 45%;
    left: 49%;
    transform: translate(-50%, -50%);
    transform: rotate(90deg);
    opacity: 0.7;
}
.thumbSomos {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-top: 35px;
    margin-bottom: 35px;
}
.thumbSomos:hover {
    opacity: 0.8;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    transition: 0.5s;
    transform:scale(1.1);
    cursor: pointer;
}
.thumbSomos:hover + .thumbLegenda  {
    text-decoration: none;
    cursor: pointer;
    transition: 0.5s;
    transform:scale(1.1);
}
.thumbLegenda {
    text-decoration: none;
    font-size: 16px;
    color:#2e2d2c;
    font-family: 'Raleway', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Verdana, sans-serif;
    font-weight: bolder;
    text-shadow: 0.2px 0.2px;
}
.thumbLegenda:hover {
    text-decoration: none;
    cursor: pointer;
    transition: 0.5s;
    transform:scale(1.1);
}

/*************** inicio do CSS de CARD SMART HOME ***********************/
.smartHome{
    height: 570px;
    width: 100%;
    background: #008fac;
}
#smartEnergy {
    background: #000 !important;
}
#BMShion {
    background: #ffd618 !important;
}
.frontendSmartHome {
    margin: 0
}
.imgBMShionParent {
    height: 570px;
    width: 100%;
}
.imgSmartHome {
    width: 960;
}
#imgBMShion {
    position: absolute;
    right: 0;
}
.smartHomeX1 {
    height: 100%;
    width: 100%;
    margin: 0;
}
.smartHomeL1 {
    height: 95px;
    margin: 0;
}
.smartHomeL2 {
    height: 95px;
    margin: 0;
}
.smartHomeL3 {
    height: 95px;
    margin: 0;
}
.smartHomeL4 {
    height: 190px;
    margin: 0;
}
.smartHomeL5 {
    height: 95px;
    margin: 0;
}
.tituloSmartHome {
    font-size: 2em;
    font-weight: bolder;
    color: #eee;
    font-family: 'Raleway', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Verdana, sans-serif;
}
#tituloBmsHionHome {
    color: #008fac !important;
}
.subTituloSmartHome {
    font-size: 1em;
    color: #eee;
    font-family: 'Raleway', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Verdana, sans-serif;
}
#subTituloBmsHionHome {
    color: #008fac !important;
}
.textoSmartHome {
    font-size: 1em;
    color: #eee;
    font-family: 'Raleway', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Verdana, sans-serif;
}
#textoBmsHionHome {
    color: #2e2d2c !important;
}
.efeitoIconSmartHome {
    font-size: 3em;
    color: #ffd618;
}
#PlaySmartEnergy {
    color: #008fac !important;
}
/* *****************************************************/

/********************** inicio do CSS de CARD CONTATO HOME **********************/
.contatoHome{
    height: 475px;
    width: 100%;
    background: #fff;
    overflow: hidden;
}
.frontendContatotHome {
    margin: 0;
}
.contatoHomeL1 {
    margin: 0;
    height: 95px;
}
.contatoHomeL2 {
    margin: 0;
    height: 285px;
}
.contatoHomeL3 {
    margin: 0;
    height: 95px;
}
.tituloContatoHome {
    font-size: 2em;
    color: #008fac;
    font-weight: bold;
    max-width: 350px;
    line-height: 1.1;
    margin-top: 35px;
}
.formContatoHome {
    width: 450px;
}
.botaoFormContato {
    background: #008fac;
    font-family: 'Play';
    width: 80px;
    border: none;
    border-radius: 17px;
    float:right;
}
#input-Nome-Contato {
    border: none;
    border-bottom: solid 2px #008fac;
}
#input-Telefone-Contato {
    border: none;
    border-bottom: solid 2px #008fac;
}
#input-Email-Contato {
    border: none;
    border-bottom: solid 2px #008fac;
}
#input-Mensagem-Contato {
    border: none;
    height: 100px;
    border-bottom: solid 2px #008fac;
    background: rgba(1, 144, 172, 0.05)
}
.efeitoLogoContatoHome1 {
    position: absolute;
    top: calc(100% - 100px);
    left: -100px;
    height: 550px;
    width: 550px;
    overflow: hidden;
}
.HionEffectHomeContato1 {
    position: relative;
    height: 100%;
    width: 100%;
    opacity: 0.1;
    transform: rotate(30deg);
}   
/*******************************************************************************/

/*********** inicio do CSS de CARD NEWSLETTER HOME *****************************/
.newsletterHome {
    height: 95px;
    width: 100%;
    background: #999;
    overflow: hidden;
}
.containerNewsletter {
    margin: 0;
}
.rowNewsletterL1 {
    margin: 0;
    height: 35px;
}
.rowNewsletterL2 {
    margin: 0;
    height: 35px;
}
.rowNewsletterL3 {
    margin: 0;
    height: 25px;
}
.textoNewsletterHome {
    font-size: 1.1em;
    font-family: 'Raleway', 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Verdana, sans-serif;
    color: #fff;
}
.inputNewsletterHome {
    top: -5px;
}
#input-Email-Newsletter {
    border:none;
    width: 300px;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
}
/*******************************************************************************/

/* MEDIA QUERY LG *************************************************/
@media (min-width: 992px) and (max-width:1365px) {

/*************** inicio do CSS de CARD SMART HOME ***********************/
.imgSmartHome {
    width: 683;
}
/****************************************************************** */

}
/* MEDIA QUERY SM e MD *************************************************************/
@media (min-width: 576px) and (max-width:991px) { /* SM  e MD */

/********** inicio do CSS de Soluções e Tecnologia ***********/
.sobreNosHome {
    height: 1137px;
}
.sobreNosHomeL2 {
    height: 585px;
}
.TituloAbout {
    height: 290px;
}
.TextoAbout {
    font-size: 18px;
}
.argdir {
    top: 20%;
    left: 47.5%;
}

/*************** inicio do CSS de CARD SMART HOME ***********************/
.smartHome{
    height: 890px;
}
.imgSmartHomeParent {
    height: 320px;
    width: 100%;
}
.imgSmartHome {
    width: 991;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

/********************************************************************** */

/********************** inicio do CSS de CARD CONTATO HOME **********************/
.contatoHome{
    height: 650px;
}
.contatoHomeL2 {
    height: 460px;
}
.tituloContatoHome {
    margin: 0 auto;
    padding-bottom: 55px;
}
.formContatoHome {
    width: 450px;
    margin: 0 auto;
}
.botaoFormContato {
    float: none;
    margin: 0 auto;
}
.efeitoLogoContatoHome1 {
    top: calc(100% - 100px);
    left: -100px;
    height: 650px;
    width: 650px;
}
.HionEffectHomeContato1 {
    transform: rotate(35deg);
}   

/********************************************************************** */

/*********** inicio do CSS de CARD NEWSLETTER HOME *****************************/
.newsletterHome {
    height: 120px;
}
.rowNewsletterL1 {
    height: 5px;
}
.rowNewsletterL2 {
    height: 65px;
}
.rowNewsletterL3 {
    height: 25px;
}
.textoNewsletterHome {
    font-size: 1.1em;
    padding-bottom: 10px;
}
.inputNewsletterHome {
    margin: 0 auto;
}
#input-Email-Newsletter {
    border:none;
    width: 300px;
    border-radius: 20px;
    margin: 0 auto;
}
/*******************************************************************************/
}
/* MEDIA QUERY XS ****************************************************/
@media (max-width:575px) { /* XS */
/* inicio do CSS de Soluções e Tecnologia */
.sobreNosHome {
    height: auto;
}
.sobreNosHomeL1 {
    height: 35px;
}
.sobreNosHomeL2 {
    height: auto;
}
.sobreNosHomeL3 {
    height: 105px;
}
.sobreNosHomeL4 {
    height: 903px;
}
.sobreNosHomeL5 {
    height: 95px;
}
.thumbSomos {
    width: 200px;
    height: 200px;  
}
.thumbLegenda {
    font-size: 1.3em;
}
.TituloAbout {
    font-size: 1.4em;
    height: auto;
}
.TextoAbout {
    font-size: 1.3em;
    height: auto;
}
.argdir {
    top: 20%;
    left: 47%;
}

/*************** inicio do CSS de CARD SMART HOME ***********************/
.smartHome{
    height: 950px;
}
.smartHomeL1 {
    height: 50px;
}
.smartHomeL2 {
    height: 140px;
}
.imgSmartHomeParent {
    height: 380px;
    width: 100%;
}
.imgSmartHome {
    width: 575;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.tituloSmartHome {
    font-size: 2em;
}
.subTituloSmartHome {
    font-size: 1.3em;
}
/* *****************************************************/

/********************** inicio do CSS de CARD CONTATO HOME **********************/
.contatoHome{
    height: 650px;
}
.contatoHomeL2 {
    height: 460px;
}
.tituloContatoHome {
    margin: 0 auto;
    padding-bottom: 55px;
    font-size: 1.5em;
    max-width: 270px;
}
.formContatoHome {
    width: 270px;
    margin: 0 auto;
}
.botaoFormContato {
    float: none;
    margin: 0 auto;
}
.efeitoLogoContatoHome1 {
    top: calc(100% - 90px);
    left: -180px;
    height: 400px;
    width: 400px;
}
.HionEffectHomeContato1 {
    transform: rotate(30deg);
}   

/********************************************************************** */

/*********** inicio do CSS de CARD NEWSLETTER HOME *****************************/
.newsletterHome {
    height: 120px;
}
.rowNewsletterL1 {
    height: 5px;
}
.rowNewsletterL2 {
    height: 65px;
}
.rowNewsletterL3 {
    height: 25px;
}
.textoNewsletterHome {
    font-size: 1.1em;
    padding-bottom: 10px;
}
.inputNewsletterHome {
    margin: 0 auto;
}
#input-Email-Newsletter {
    border:none;
    width: 300px;
    border-radius: 20px;
    margin: 0 auto;
}
/*******************************************************************************/

}
</style>